// extracted by css-extract-rspack-plugin
export default {"section":"T5ItGgZ4UdY8dJZc"};